import client from '@/lib/feathers';

export const getName = async () => {
  try {
    const res = await client.service('communityData').find({
      query: {
        $select: ['englishName'],
      },
    });
    if (Array.isArray(res.data) && res.data.length > 0) {
      return res.data[0].englishName;
    } else {
      return '';
    }
  } catch (err) {
    console.error(err);
  }
};
export const getSorter = <T>(dataIndex: string) => {
  const sorter = (a: T, b: T): number => {
    const [valueA, valueB] = [a[dataIndex], b[dataIndex]];
    if (valueA?.toString && valueB?.toString) {
      return valueA.toString().localeCompare(valueB.toString());
    }
    return 0;
  };
  return sorter;
};
